import { render, staticRenderFns } from "./Unauthorised.vue?vue&type=template&id=80e24876&scoped=true"
import script from "./Unauthorised.vue?vue&type=script&lang=js"
export * from "./Unauthorised.vue?vue&type=script&lang=js"
import style0 from "./Unauthorised.vue?vue&type=style&index=0&id=80e24876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e24876",
  null
  
)

export default component.exports